import Vue from "vue";
import CompanyService from "@/service/company-service";
import uuid from "uuid";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import { zLanguageChanger, zGuestDetail } from "zoox-components";
import { ApiClient } from "zoox-infra";
import moment from "moment";

export default {
  name: "Resume",
  mixins: [sessionMixin],
  components: {
    "z-language-changer": zLanguageChanger,
    "z-guest-detail": zGuestDetail
  },
  data() {
    return {
      customLogo: "",
      companyService: new CompanyService(),
      apiClient: new ApiClient(Vue),
      openGuestSelect: false,
      requestReady: false,
      customMessages: {},
      company: {},
      fnrhId: this.$route.params.fnrhId,
      data: {},
      mapHtml: "",
      companyFnrh: {},
      checkinDate: null,
      checkoutDate: null,
      successUrl: null
    };
  },
  created() {
    // sempre que entramos na tela, damos scroll para o topo
    // pois por vezes o scroll vem alterado da tela anterior
    $(document).ready(function() {
      $(this).scrollTop(0);
    });
  },
  computed: {
    customMessage: function() {
      const currentLang = this.$i18n.locale;

      return (
        this.customMessages[`message_${currentLang}`] ||
        this.customMessages[`message_en`] ||
        this.customMessages["message"]
      );
    }
  },
  mounted() {
    this.$resetState();

    this.company = this.companyService.getLocalCompany();
    const customizationSettings = this.companyService.getLocalCustomizationSettings();
    if (customizationSettings && customizationSettings.portalLogoUrl) {
      this.customLogo = customizationSettings.portalLogoUrl;
    }

    if (this.company && this.company.id && this.fnrhId) {
      this.getPageData(this.company.id, this.fnrhId).then(async resp => {
        this.requestReady = true;
        this.data = resp.fnrhData;
        this.mapHtml = resp.imageMap;
        this.companyFnrh = resp.companyFields;

        this.checkinDate = moment(this.data.checkinDate)
          .utc()
          .format("YYYY-MM-DD");

        this.checkoutDate = moment(this.data.checkoutDate)
          .utc()
          .format("YYYY-MM-DD");

        this.dates = [this.checkinDate, this.checkoutDate];
      });
      this.companyService.getFnrhMessageSettings(this.company.id).then(resp => {
        this.customMessages = resp;
      });
    }
  },
  methods: {
    getFullName: function() {
      return this.data.name + " " + this.data.lastName;
    },
    getFullAddress: function() {
      return `${this.companyFnrh.address}, ${this.companyFnrh.zipCode}`;
    },
    getCustomLogo: function() {
      return this.customLogo
        ? this.customLogo + `?unique=${uuid.v4()}`
        : require("@/assets/images/placeholder.png");
    },
    getPageData: function(comnpanyId, fnrhId) {
      return this.apiClient.get(`open/fnrh-resume/${comnpanyId}/${fnrhId}`);
    }
  }
};
